module.exports = __webpack_public_path__ + "static/media/roboto-regular-webfont.7b0cc0ca.ttf";